import React from 'react';
import Translate from '../Translate/Translate';

function ExampleTooltip({ example }) {
    return (
        <div
            style={{
                maxHeight: '20rem',
                overflowY: 'hidden',
                overflowX: 'auto'
            }}
            className="text-start"
            id="example-tooltip"
        >
            <span className="title h6 p-0 m-0 mb-3 me-3">
                <Translate message="Example" />
            </span>
            <br />
            <span>{example}</span>
        </div>
    );
}

export default ExampleTooltip;
